// extracted by mini-css-extract-plugin
export default {"contents":"xF-z","sectionHeading":"yF-z"};